import { render, staticRenderFns } from "./ModalNuevoAdmin.vue?vue&type=template&id=6e85dc62"
import script from "./ModalNuevoAdmin.vue?vue&type=script&lang=js"
export * from "./ModalNuevoAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports